import { useCallback, useEffect } from 'react';
import { EventEmitter } from 'events';

import { MapsApi } from '../../../../../../../../api';
import Geo, { getCountryName } from '../../../../../../../../services/geo';

const AddressValidatorEventEmitter = new EventEmitter();

export default function AddressValidator({ data, setAddressFields }) {
  const revalidate = useCallback(
    function() {
      const { countryId, regionId, city, address1: address, zipCode: zip } = data;
      if (!countryId || !regionId || !city || !address) {
        return;
      }
      Geo.getRegion(countryId, regionId).then(function(region) {
        MapsApi.validateAddress({
          country: getCountryName(countryId),
          region: region.localName || region.name || null,
          city,
          address,
          zip: zip || null
        }).then(
          function({ data }) {
            if (data.validIgnoringZip && data.zip) {
              setAddressFields({ valid: true, zipCode: data.zip });
            } else {
              setAddressFields({ valid: false });
            }
          },
          () => {
            setAddressFields({ valid: false });
          }
        );
      });
    },
    [data, setAddressFields]
  );

  useEffect(
    function() {
      AddressValidatorEventEmitter.on('change-state', listener);
      return function() {
        AddressValidatorEventEmitter.removeListener('change-state', listener);
      };
      function listener({ type, key }) {
        if (type === 'REVALIDATE') {
          revalidate(key);
        }
      }
    },
    [revalidate]
  );

  return null;
}

AddressValidator.revalidate = function(key) {
  setTimeout(function() {
    AddressValidatorEventEmitter.emit('change-state', { type: 'REVALIDATE', key });
  }, 100);
};
